import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Paper,
  Typography,
  IconButton,
  Modal,
  Button,
  TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useAuth from "./useAuth";
import { useNotification } from "../../components/NotificationContext";
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  };
const ProductDiscountEdit = () => {
  useAuth();
  const navigate = useNavigate();
  const showNotification = useNotification();

  const [discounts, setDiscounts] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [formData, setFormData] = useState({
    discount_price: "",
    start_date: "",
    end_date: "",
  });

  const fetchDiscounts = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/product/discounts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDiscounts(res.data);

    } catch (error) {
      showNotification("İndirimler alınamadı!", "error");
    }
  };

  useEffect(() => {
    fetchDiscounts();
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  const openModal = (discount) => {
    setSelectedDiscount(discount);
    setFormData({
      discounted_price: discount.discounted_price,
      start_date: formatDateForInput(discount.start_date),
      end_date: formatDateForInput(discount.end_date),
    });
  };


  const closeModal = () => {
    setSelectedDiscount(null);
    setFormData({
      discounted_price: "",
      start_date: "",
      end_date: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(`${process.env.REACT_APP_API_URL}/product/discounts/${selectedDiscount.id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      showNotification("İndirim başarıyla güncellendi", "success");
      closeModal();
      fetchDiscounts();
    } catch (error) {

      const msg = error.response?.data?.message || "Güncelleme sırasında hata oluştu.";
      showNotification(msg, "error");
    }
  };

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${process.env.REACT_APP_API_URL}/product/discounts/delete/${selectedDiscount.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      showNotification("İndirim başarıyla silindi", "success");
      closeModal();
      fetchDiscounts();
    } catch (error) {

      const msg = error.response?.data?.message || "Silme sırasında hata oluştu.";
      showNotification(msg, "error");
    }
  };

  const formatDateForInput = (utcDateString) => {
    const localDate = new Date(utcDateString);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid size={{ xs: 12, sm: 10,md:10 }}>
        <Paper elevation={5} style={{ padding: "30px", borderRadius: "15px", backgroundColor: "#ffffff" }}>
          <IconButton onClick={handleBackClick} style={{ marginBottom: "10px" }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" align="center" gutterBottom style={{ fontWeight: 600, color: "#3f51b5" }}>
            Ürün İndirimi Güncelle
          </Typography>

          <Grid container spacing={2}>
            {discounts.map((discount) => (
              <Grid size={{ xs: 12, sm: 6,md:4 }} key={discount.id}>
                <Paper
                  onClick={() => openModal(discount)}
                  elevation={3}
                  sx={{ p: 2, cursor: "pointer", border: "1px solid #ccc" }}
                >
                  <Typography variant="h6">{discount.product_name}</Typography>
                  <Typography variant="body2">İndirimli: {discount.discounted_price} TL</Typography>
                  <Typography variant="body2">
  {
    (() => {
      const today = new Date();
      const startDate = new Date(discount.start_date);
      const endDate = new Date(discount.end_date);

      const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());


      if (todayDateOnly >= endDateOnly) return "İndirim sonlandı";

      const diffToStart = Math.ceil((startDateOnly - todayDateOnly) / (1000 * 60 * 60 * 24));
      const diffToEnd = Math.ceil((endDateOnly - todayDateOnly) / (1000 * 60 * 60 * 24));

      if (diffToStart > 1) return `${diffToStart} gün sonra başlayacak`;
      if (diffToStart === 1) return "Yarın başlayacak";
      if (diffToStart === 0) return "İndirim bugün başladı";

      if (diffToEnd === 1) return "İndirim yarın bitiyor";
      return `İndirim ${diffToEnd} gün sonra bitiyor`;
    })()
  }
</Typography>




                </Paper>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Grid>

      {/* Modal */}
      <Modal open={!!selectedDiscount} onClose={closeModal}>
  <Box sx={modalStyle}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography variant="h6">İndirimi Güncelle</Typography>
      <IconButton onClick={closeModal}>
        <CloseIcon />
      </IconButton>
    </Box>

    <TextField
      label="İndirimli Fiyat"
      name="discounted_price"
      value={formData.discounted_price}
      onChange={handleChange}
      fullWidth
    />
    <TextField
      label="Başlangıç Tarihi"
      name="start_date"
      type="date"
      value={formData.start_date}
      onChange={handleChange}
      fullWidth
      InputLabelProps={{ shrink: true }}
    />
    <TextField
      label="Bitiş Tarihi"
      name="end_date"
      type="date"
      value={formData.end_date}
      onChange={handleChange}
      fullWidth
      InputLabelProps={{ shrink: true }}
    />

    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
      <Button onClick={handleDelete} color="error" variant="outlined">
        Sil
      </Button>
      <Button onClick={handleUpdate} variant="contained" color="primary">
        Güncelle
      </Button>
    </Box>
  </Box>
</Modal>

    </Grid>
  );
};

export default ProductDiscountEdit;
